import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpen, ArrowUpRight } from 'lucide-react';

/**
 * MethodologyLink — Trust Infrastructure component.
 *
 * Compact inline link that opens the corresponding methodology page. Should
 * appear on every chart / numeric output of the Predict module.
 *
 * Props:
 *   module: 'historical-yield' | 'water-calculator' | 'pest-tracker' | 'budget'
 *   label: optional override, default 'Methodology'
 *   newTab: open in new tab (default true — methodology should never displace user's work)
 */
export default function MethodologyLink({ module, label = 'Methodology', newTab = true }) {
  const navigate = useNavigate();
  const href = `/predict/methodology/${module}`;

  const handleClick = (e) => {
    if (newTab) return; // let anchor handle it
    e.preventDefault();
    navigate(href);
  };

  return (
    <a
      href={href}
      target={newTab ? '_blank' : undefined}
      rel={newTab ? 'noopener noreferrer' : undefined}
      onClick={handleClick}
      className="inline-flex items-center gap-1 transition-colors"
      style={{
        fontSize: 11.5,
        color: '#2D6A4F',
        textDecoration: 'none',
        padding: '3px 7px',
        borderRadius: 6,
        background: '#EAF2E5',
        border: '1px solid #C8DBC0',
        fontWeight: 500,
        letterSpacing: '0.01em',
      }}
      onMouseEnter={(e) => { e.currentTarget.style.background = '#D8E5DC'; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = '#EAF2E5'; }}
      data-testid={`methodology-link-${module}`}
    >
      <BookOpen size={11} />
      <span>{label}</span>
      {newTab && <ArrowUpRight size={10} style={{ marginLeft: 1 }} />}
    </a>
  );
}
